import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";

export default <T,>({ name, label, formik, placeholder, onChange, containerClassName, ...props }: IInputProps<T, string>) => {
    return (
        <InputContainer label={label} name={name} formik={formik} className={containerClassName}>
            <StringInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} {...props} />
        </InputContainer>
    );
}

export const StringInputRow = <T,>({ name, label, formik, placeholder, onChange, containerClassName, ...props }: IInputProps<T, string>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik} className={containerClassName}>
            <StringInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} {...props} />
        </InputContainerRow>
    );
}

export const StringInputSlim = <T,>({ name, formik, placeholder, onChange, ...props }: ISlimInputProps<T, string>) => {
    return (
        <input
            type="text"
            name={name as string}
            value={formik.values[name] as string || ""}
            onChange={e => {
                const value = e.target.value || null;
                formik.setValues({
                    ...formik.values,
                    [name]: value,
                    ...onChange ? onChange(value) : {},
                });
            }}
            onBlur={formik.handleBlur}
            placeholder={placeholder}
            {...props}
        />
    );
}